// 全局配置
let EDRAWMAX_PRODUCT_ENV = process.env.EDRAWMAX_PRODUCT_ENV || "production";
if (process.env.NODE_ENV === "development") {
    EDRAWMAX_PRODUCT_ENV = "test37";
}

let EDRAWMAX_PRODUCT_API = process.env.EDRAWMAX_PRODUCT_API;
let EDRAWMAX_PRODUCT_VIPLIMIT = process.env.EDRAWMAX_PRODUCT_VIPLIMIT || false;

// *** test
// EDRAWMAX_PRODUCT_ENV = 'board'
// EDRAWMAX_PRODUCT_ENV = 'private'
// EDRAWMAX_PRODUCT_ENV = 'workwx'
// EDRAWMAX_PRODUCT_API = 'http://tt.edrawmax.cn/'

if (EDRAWMAX_PRODUCT_ENV == "production" || EDRAWMAX_PRODUCT_ENV == "teamsapp" || EDRAWMAX_PRODUCT_ENV == "test37") {
    EDRAWMAX_PRODUCT_VIPLIMIT = true;
}
if (EDRAWMAX_PRODUCT_ENV == "plugin" || EDRAWMAX_PRODUCT_ENV == "board") {
    EDRAWMAX_PRODUCT_VIPLIMIT = false;
}

export { EDRAWMAX_PRODUCT_ENV, EDRAWMAX_PRODUCT_API, EDRAWMAX_PRODUCT_VIPLIMIT };
